// Function to safely parse a number from a string
function safeParseFloat(value) {
  if (typeof value === 'string') {
    value = value.replace(/[^0-9.]/g, '');
  }
  const parsed = parseFloat(value);
  return isNaN(parsed) ? 0 : parsed;
}

function formatPrice(price, { showCents = false } = {}) {
  const amount = Number(price);
  const hasCents = showCents || Math.round(amount * 100) % 100 !== 0;
  return (
    '$' +
    amount.toLocaleString('en-US', {
      minimumFractionDigits: hasCents ? 2 : 0,
      maximumFractionDigits: 2,
    })
  );
}

// Function to update the total price
function updateTotalPrice() {
  const displayPriceElement = document.getElementById('display-price');
  const addOnTotalElement = document.getElementById('add-on-total');
  const totalPriceElement = document.getElementById('total-price');
  const installFeeElement = document.getElementById('install-fee');
  const installFeeWaivedElement = document.getElementById('install-fee-waived');

  if (!displayPriceElement || !addOnTotalElement || !totalPriceElement) {
    console.error('Could not find required price elements');
    return;
  }

  let basePrice = safeParseFloat(displayPriceElement.textContent);
  let optionsPrice = 0;
  let requiredAddOnPrice = 0;

  document.querySelectorAll('input[data-price]:checked').forEach((input) => {
    if (input.disabled) return;
    const wrapper = input.closest('.add-on-product-wrapper');
    if (wrapper) {
      const wrapperDisplay = wrapper.style.display || window.getComputedStyle(wrapper).display;
      if (wrapperDisplay === 'none') return;
    }
    const price = safeParseFloat(input.getAttribute('data-price'));
    if (input.closest('#add-on-products')) {
      requiredAddOnPrice += price;
    } else {
      optionsPrice += price;
    }
  });

  const extrasPrice = optionsPrice + requiredAddOnPrice;

  // Calculate install fee (waived if add-ons >= $2000)
  // Only calculate if install fee is active (element exists)
  let installFee = 0;
  let isInstallFeeWaived = false;

  if (installFeeElement) {
    const installFeeText = installFeeElement.textContent;
    const installFeeMatch = installFeeText.match(/\$?([0-9,]+\.?[0-9]*)/);
    if (installFeeMatch) {
      installFee = parseFloat(installFeeMatch[1].replace(/,/g, ''));
    }
    isInstallFeeWaived = extrasPrice >= 2000;
  }

  const finalInstallFee = isInstallFeeWaived ? 0 : installFee;

  const taxableCents = Math.round((basePrice + extrasPrice + finalInstallFee) * 100);
  const locationSelector = document.querySelector('install-location-selector');
  const locationCharges =
    locationSelector && typeof locationSelector.getCharges === 'function'
      ? locationSelector.getCharges(taxableCents)
      : null;
  const shippingFee = locationCharges ? locationCharges.shippingCents / 100 : 0;

  let totalPrice = basePrice + extrasPrice + finalInstallFee + shippingFee;

  displayPriceElement.textContent = formatPrice(basePrice, { showCents: true });
  addOnTotalElement.textContent = formatPrice(optionsPrice, { showCents: true });
  const requiredAddOnsElement = document.getElementById('required-addons-total');
  if (requiredAddOnsElement) requiredAddOnsElement.textContent = formatPrice(requiredAddOnPrice, { showCents: true });
  totalPriceElement.textContent = formatPrice(totalPrice);
  const buildTotalElement = document.getElementById('build-total-price');
  if (buildTotalElement) buildTotalElement.textContent = formatPrice(totalPrice, { showCents: true });

  const addOnContainer = document.getElementById('add-on-total-container');
  if (addOnContainer) addOnContainer.hidden = optionsPrice <= 0;
  const requiredAddOnsContainer = document.getElementById('required-addons-container');
  if (requiredAddOnsContainer) requiredAddOnsContainer.hidden = requiredAddOnPrice <= 0;

  // Update install fee display
  if (installFeeElement && installFeeWaivedElement) {
    if (isInstallFeeWaived) {
      installFeeElement.style.display = 'none';
      installFeeWaivedElement.style.display = 'inline';
    } else {
      installFeeElement.style.display = 'inline';
      installFeeWaivedElement.style.display = 'none';
    }
  }

  // Update hidden input field for checkout (only if install fee is active)
  const installFeeInput = document.getElementById('install-fee-input');
  if (installFeeInput && installFeeElement) {
    const installFeeFormatted = formatPrice(installFee, { showCents: true });
    installFeeInput.value = isInstallFeeWaived ? '$0.00 (Waived)' : installFeeFormatted;
  }

  const shippingContainer = document.getElementById('shipping-fee-container');
  const shippingFeeElement = document.getElementById('shipping-fee');

  if (shippingContainer && shippingFeeElement) {
    shippingContainer.hidden = !locationCharges;
    if (locationCharges) shippingFeeElement.textContent = formatPrice(shippingFee, { showCents: true });
  }
}

// Function to handle conditional inputs visibility
function handleConditionalInputs() {
  const addOnWrappers = document.querySelectorAll('.add-on-product-wrapper');

  addOnWrappers.forEach((wrapper, index) => {
    const input = wrapper.querySelector('input');
    if (input) {
      const isVisible = window.getComputedStyle(wrapper).display !== 'none';

      if (isVisible && input.type === 'radio' && !input.checked) {
        // Check if this is the only visible radio in its group
        const name = input.getAttribute('name');
        const visibleRadiosInGroup = document.querySelectorAll(
          `.add-on-product-wrapper:not([style*="display: none"]) input[type="radio"][name="${name}"]`
        );
        if (visibleRadiosInGroup.length === 1) {
          input.checked = true; // Auto-select if it's the only visible option
        }
      } else if (!isVisible && input.checked) {
        input.checked = false; // Uncheck hidden inputs
      }

      // Manage the required attribute based on visibility
      if (isVisible) {
        input.setAttribute('required', 'required');
      } else {
        input.removeAttribute('required');
      }
    }
  });

  updateTotalPrice();
}

// Function to handle vehicle selection changes
function handleVehicleChange() {
  const vehicleSelector = document.querySelector('.disclosure__button span[data-label="Models"]');
  const addOnWrappers = document.querySelectorAll('.add-on-product-wrapper');

  if (vehicleSelector) {
    const selectedVehicle = vehicleSelector.textContent.trim();

    addOnWrappers.forEach((wrapper, index) => {
      if (wrapper.closest('#add-on-products')) return;

      const input = wrapper.querySelector('input');
      if (input) {
        const compatibleVehicles = input.getAttribute('data-compatible-vehicles');

        // Check if the add-on is compatible with the selected vehicle
        const isCompatible = compatibleVehicles && compatibleVehicles.includes(selectedVehicle);

        if (isCompatible) {
          wrapper.style.display = 'block';
        } else {
          wrapper.style.display = 'none';
          input.checked = false;
        }
      }
    });
  }

  handleConditionalInputs();
}

// Function to get the current variant ID from the URL
function getCurrentVariantId() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('variant');
}

// Function to initialize all price updates and observers
function initializePriceUpdates() {
  // Listen for checkbox and radio button changes
  document.addEventListener('change', (event) => {
    if (event.target.matches('input[type="checkbox"][data-price], input[type="radio"][data-price]')) {
      updateTotalPrice();
    }
  });

  // Listen for vehicle selection changes
  const vehicleSelector = document.querySelector('.disclosure__button[aria-controls="vehicle-model-list"]');
  if (vehicleSelector) {
    vehicleSelector.addEventListener('click', () => {
      setTimeout(handleVehicleChange, 100); // Short delay to ensure the selection has updated
    });
  }

  // Listen for changes that might affect conditional inputs
  const configOptions = document.querySelectorAll('.product-form__input');
  configOptions.forEach((option) => {
    option.addEventListener('change', handleConditionalInputs);
  });

  // Observe visibility changes
  const visibilityObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
        handleConditionalInputs();
      }
    });
  });

  const addOnContainer = document.getElementById('add-on-products');
  if (addOnContainer) {
    visibilityObserver.observe(addOnContainer, {
      attributes: true,
      subtree: true,
      attributeFilter: ['style'],
    });
  }

  // Initialize the URL observer
  let currentVariantId = getCurrentVariantId();
  const urlObserver = new MutationObserver(() => {
    const newVariantId = getCurrentVariantId();
    if (newVariantId !== currentVariantId) {
      // console.log('Variant changed from', currentVariantId, 'to', newVariantId);
      currentVariantId = newVariantId;
      // Wait a short moment for any other scripts to update prices
      setTimeout(() => {
        // console.log('Updating prices after variant change');
        updateTotalPrice();
      }, 1000);
    }
  });

  urlObserver.observe(document.body, { subtree: true, childList: true });

  // Initial setup
  handleVehicleChange();
  updateTotalPrice();
}

// Run the initialization when the DOM is fully loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializePriceUpdates);
} else {
  initializePriceUpdates();
}

document.addEventListener('price:update', () => {
  updateTotalPrice();
});

document.addEventListener('installLocationSelected', () => {
  updateTotalPrice();
});
